export function getLargestShippingGroupByBasketItems(
  items: { shippingGroup: string }[] = []
) {
  return items.reduce(
    (largestShippingGroup, item) =>
      largestShippingGroup.localeCompare(item.shippingGroup) > 0
        ? largestShippingGroup
        : item.shippingGroup,
    'A'
  );
}
